var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"href":_vm.href,"target":"_blank","title":_vm.title}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.config.line))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }